export default {
  "content": "<path d=\"M6 0a6 6 0 100 12A6 6 0 006 0zm0 9.75a.75.75 0 110-1.5.75.75 0 010 1.5zM6.75 6a.75.75 0 11-1.5 0V3a.75.75 0 011.5 0v3z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "12",
    "height": "12",
    "viewBox": "0 0 12 12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};